import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosGet from "../axios/axios-get";
import axiosDelete from "../axios/axios-delete";

const BASE_URL = "/calculate";

export const HeatingCalculationAPI = Object.freeze({
  getAll: createAsyncThunk(
    "get/get-heating-calculations",
    async (params, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(BASE_URL, { params });
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  remove: createAsyncThunk(
    "delete/delete-heating-calculation",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosDelete.delete(`${BASE_URL}/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),
});
